import type { SearchParamsObject } from '@algolia/client-search';

import type { ApiAreaOfFocus } from '#/api/types/ApiAreaOfFocus';
import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFiltersById } from '#/modules/search/types/SearchFiltersById';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';

import { searchAlgoliaEventsOptions } from './searchAlgoliaEventsOptions';
import { searchAlgoliaGroupsOptions } from './searchAlgoliaGroupsOptions';
import { searchAlgoliaInternshipsOptions } from './searchAlgoliaInternshipsOptions';
import { searchAlgoliaJobsOptions } from './searchAlgoliaJobsOptions';
import { searchAlgoliaOrgsOptions } from './searchAlgoliaOrgsOptions';
import { searchAlgoliaVolopsOptions } from './searchAlgoliaVolopsOptions';

type Args = {
  i18n: I18nFn;
  filtersById: SearchFiltersById;
  searchLocation: SearchLocation | undefined;
  excludedAreasOfFocus: ApiAreaOfFocus[];
};

export function searchAlgoliaOptionsSwitch({
  i18n,
  filtersById,
  searchLocation,
  excludedAreasOfFocus,
}: Args): SearchParamsObject {
  switch (filtersById.type) {
    case 'JOB':
      return searchAlgoliaJobsOptions({ i18n, filtersById, searchLocation });
    case 'VOLOP':
      return searchAlgoliaVolopsOptions({
        i18n,
        filtersById,
        searchLocation,
        excludedAreasOfFocus,
      });
    case 'EVENT':
      return searchAlgoliaEventsOptions({ i18n, filtersById, searchLocation });
    case 'INTERNSHIP':
      return searchAlgoliaInternshipsOptions({
        i18n,
        filtersById,
        searchLocation,
      });
    case 'ORG':
      return searchAlgoliaOrgsOptions({ i18n, filtersById, searchLocation });
    case 'GROUP':
      return searchAlgoliaGroupsOptions({ i18n, filtersById, searchLocation });
  }
}
